// extracted by mini-css-extract-plugin
export default {"settings":"style_settings__t5RLX","settings__checkbox":"style_settings__checkbox__f62Zy","render":"style_render__1y0x9"};